var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-preferred-contact",
    transform: "translate(-340.000000, -384.000000)",
    fill: "#585D63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-sms",
    transform: "translate(340.000000, 381.000000)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 17 3 C 18.657 3 20 4.343 20 6 L 20 12.727 C 20 14.384 18.657 15.727 17 15.727 L 3 15.727 C 1.343 15.727 0 14.384 0 12.727 L 0 6 C 0 4.343 1.343 3 3 3 L 17 3 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 4.963 12.224 L 3.682 6.855 L 4.791 6.855 L 5.601 10.543 L 6.582 6.855 L 7.871 6.855 L 8.812 10.605 L 9.636 6.855 L 10.728 6.855 L 9.424 12.224 L 8.274 12.224 L 7.205 8.21 L 6.139 12.224 Z M 11.294 12.224 L 11.294 6.855 L 12.378 6.855 L 12.378 9.239 L 14.568 6.855 L 16.026 6.855 L 14.004 8.946 L 16.136 12.224 L 14.733 12.224 L 13.257 9.704 L 12.378 10.602 L 12.378 12.224 Z",
    style: {
      fill: "rgb(255, 255, 255)",
      whiteSpace: "pre"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWk);
export default __webpack_public_path__ + "static/media/WK.3f647a54caae1eb556f2801ae7beaff9.svg";
export { ForwardRef as ReactComponent };